// @ts-nocheck
import { createFileRoute } from '@tanstack/react-router';
import CustomerZoneInvoiceListPage from '@/PageComponents/CustomerZone/CustomerZoneInvoice/CustomerZoneInvoiceListPage';

export default CustomerZoneInvoiceListPage;
export const Route = createFileRoute('/_customerzoneLayout/customerzone/invoicelist')({ component: CustomerZoneInvoiceListPage });
